import { contactInfo } from "@/mocks/home";

export default function CallButton() {
  return (
    <a
      href={contactInfo.phoneHref}
      className="fixed bottom-20 right-4 md:right-6 z-50 flex items-center gap-2 bg-brandgreen hover:bg-brandgreen-dark text-white px-4 py-3 rounded-full shadow-lg transition-all hover:scale-105 cursor-pointer md:hidden"
      aria-label="Llamar ahora"
    >
      <span className="w-5 h-5 flex items-center justify-center">
        <i className="ri-phone-line text-lg" />
      </span>
      <span className="text-sm font-medium whitespace-nowrap">Llamar ahora</span>
    </a>
  );
}